import { ClientApp } from './ClientApp';
import { RedeemApp } from './RedeemApp';
import { StaffApp } from './StaffApp';
import { StaffAdministrationApp } from './StaffAdministrationApp';
import { FIRM_NAME } from '../shared/firm';

export function App() {
	const path = window.location.pathname;
	let page;
	if (path === '/c') page = <RedeemApp />;
	else if (path.startsWith('/questionnaire')) page = <ClientApp />;
	else if (path.startsWith('/staff/admin')) page = <StaffAdministrationApp />;
	else if (path.startsWith('/staff')) page = <StaffApp />;
	else
		page = (
			<main id="main" className="centered-panel">
				<span className="eyebrow">{FIRM_NAME}</span>
				<h1>Estate Planning Intake</h1>
				<p>Clients should use the private link sent by the firm.</p>
				<a className="button-link" href="/staff">
					Staff sign in
				</a>
			</main>
		);
	const showTestBanner =
		window.location.hostname === 'bz-intake.silentoperator.ai' || ['localhost', '127.0.0.1'].includes(window.location.hostname);
	return (
		<div className={path.startsWith('/staff') && !path.startsWith('/staff/admin') ? 'staff-workspace' : undefined}>
			{showTestBanner && (
				<div className="test-banner" role="status">
					Test environment — use fictional information only
				</div>
			)}
			{page}
		</div>
	);
}
